import { render, staticRenderFns } from "./cly-metric-breakdown.vue?vue&type=template&id=87e7bb0a"
import script from "./cly-metric-breakdown.vue?vue&type=script&lang=js"
export * from "./cly-metric-breakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports